
import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as DashboardRoute from "./dashboard";
import * as BucketsRoute from "./buckets";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// Buckets is the section you work in, so the root still lands there.
//
// /dashboard renders a real page now. It had been a redirect to /bucket —
// itself an improvement on rendering an empty page, which is what it did when
// nothing routed it at all — and it is where the sign-in flow and any existing
// bookmark point, so it is the natural home for the organization-wide summary
// rather than a new path nobody links to. datum made the same move for the same
// reason.
const RootRoute = () => <Redirect to={`/bucket`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"BucketWS"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "file-o",
                  label: "Buckets",
                  to: `/bucket`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                }/*,
            {
              icon: "cogs",
              label: "Configuration",
              to: `/config`,
            },*/
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/dashboard`} component={DashboardRoute.Indice} />
                  <Route path={`/bucket`} component={BucketsRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/bucket`} component={BucketsRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
